function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Descriptions, Space, Form, Drawer, Breadcrumb, Typography, Dropdown, Result, Image, Modal, DatePicker, Divider, Tag, Input, notification } from 'antd';
import { Table } from 'react-bootstrap';
import { ListUl, Search as SearchIcon, GraphUpArrow, HourglassSplit, Upload as UploadIc, PencilSquare, ImageFill, EyeFill, ThreeDotsVertical } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import Moment from 'react-moment';
import SetImResult from "../components/forms/SetImResult";
import SetImFile from "../components/forms/SetImFile";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { Parser } from 'html-to-react';
import ImResultView from "../components/ImResultView";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import moment from 'moment';
import SearchActivity from "../components/SearchActivity";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Text = Typography.Text;
var Search = Input.Search;
var RangePicker = DatePicker.RangePicker;
var Echographie = function Echographie() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    currentDept = _useState2[0],
    setCurrentDept = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    deptList = _useState4[0],
    setDeptList = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isDeptDataLoading = _useState6[0],
    setIsDeptDataLoading = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    queueData = _useState8[0],
    setQueueData = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    searchQueueData = _useState0[0],
    setSearchQueueData = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    searchLoading = _useState10[0],
    setSearchQueueLoading = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    currentQueueItem = _useState12[0],
    setCurrentQueueItem = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    searchId = _useState14[0],
    setSearchId = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    dataChanged = _useState16[0],
    setDataChanged = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showTranslate = _useState18[0],
    setShowTranslate = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showEditTranslate = _useState20[0],
    setShowEditTranslate = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showImageInput = _useState22[0],
    setShowImageInput = _useState22[1];
  var _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    selectedItem = _useState24[0],
    setSelectedItem = _useState24[1];
  var _useState25 = useState(null),
    _useState26 = _slicedToArray(_useState25, 2),
    selectedQueueElement = _useState26[0],
    setSelectedQueueElement = _useState26[1];
  var _useState27 = useState(null),
    _useState28 = _slicedToArray(_useState27, 2),
    from = _useState28[0],
    setFrom = _useState28[1];
  var _useState29 = useState(null),
    _useState30 = _slicedToArray(_useState29, 2),
    to = _useState30[0],
    setTo = _useState30[1];
  var ref = useRef();
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    showResult = _useState32[0],
    setShowResult = _useState32[1];
  var onSearch = function onSearch(v) {
    setSearchId('');
    if (v.length > 0) {
      setSearchId(v);
      //setIsPatientModalOpen(true); 
    }
  };
  var onSelectPeriodFinish = function onSelectPeriodFinish(values) {
    setFrom(values.period[0].$d);
    setTo(values.period[1].$d);
    axios.get(Common.baseApiUrl + "getperiodqueue/" + currentDept.id.toString() + "/" + moment(values.period[0].$d).format() + "/" + moment(values.period[1].$d).format()).then(function (qresponse) {
      setSearchQueueData(qresponse.data.queueItems);
    })["catch"](function (error) {
      message.error({
        content: error.toString(),
        delay: 4
      });
    })["finally"](function () {
      setSearchQueueLoading(false);
    });
  };
  useEffect(function () {
    setDataChanged(false);
    axios.get(Common.baseApiUrl + "getdepartments").then(function (response) {
      if (response.data.status == 200) {
        setDeptList(response.data.departments);
        var dep;
        dep = response.data.departments.filter(function (d) {
          return d.dcode == 'ECH';
        });

        //let dep = response.data.departments.filter(d => d.dcode == 'CON');    
        var req;
        if (dep.length == 1) {
          setCurrentDept(dep[0]);
          req = Common.baseApiUrl + "getdailyqueue/" + dep[0].id.toString() + "/" + Common.currentUser.id;
        }
        if (dep.length == 2) {
          setCurrentDept(dep[0]);
          req = Common.baseApiUrl + "getdailyqueue/" + dep[0].id.toString() + "," + dep[1].id.toString() + "/" + Common.currentUser.id;
        }
        axios.get(req).then(function (qresponse) {
          setQueueData(qresponse.data.queueItems);
        })["catch"](function (error) {
          message.error({
            content: error.toString(),
            delay: 4
          });
        })["finally"](function () {
          setIsDeptDataLoading(false);
        });
      }
    })["catch"](function (error) {
      message.error({
        content: error.toString(),
        delay: 4
      });
    })["finally"](function () {});
  }, [dataChanged]);
  useEffect(function () {
    setInterval(function () {
      setDataChanged(true);
    }, 30000);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [/*#__PURE__*/_jsxs(Breadcrumb, {
            children: [/*#__PURE__*/_jsx(Breadcrumb.Item, {
              children: "Traitement"
            }), /*#__PURE__*/_jsx(Breadcrumb.Item, {
              children: /*#__PURE__*/_jsx("a", {
                href: "#",
                children: "ECHOGRAPHIE"
              })
            })]
          }), /*#__PURE__*/_jsxs(Tabs, {
            animated: true,
            defaultActiveKey: 1,
            children: [/*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(ImageFill, {
                  size: 35
                }), " Traitement"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Code P."
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Telephone"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte"
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 0;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Moment, {
                            format: "DD/MM/YYYY HH:mm",
                            children: q.created_at
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.idnumber
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname + " " + q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.mobile.toString().slice(3)
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Space, {
                            direction: "horizontal",
                            children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                              return /*#__PURE__*/_jsx(Dropdown, {
                                placement: "bottomLeft",
                                menu: {
                                  items: [{
                                    key: '1' + e.id,
                                    label: /*#__PURE__*/_jsxs(Button, {
                                      type: "default",
                                      onClick: function onClick() {
                                        setCurrentQueueItem(q);
                                        setSelectedQueueElement(e);
                                        setShowResult(true);
                                        setSelectedItem(e.business_account_medical_item);
                                      },
                                      children: [/*#__PURE__*/_jsx(EyeFill, {
                                        size: 18
                                      }), " VOIR"]
                                    })
                                  }, {
                                    key: '2' + q.id,
                                    label: /*#__PURE__*/_jsx(Button, {
                                      type: "default",
                                      onClick: function onClick() {
                                        setCurrentQueueItem(q);
                                        setShowTranslate(true);
                                        setSelectedQueueElement(e);
                                        setSelectedItem(e.business_account_medical_item);
                                      },
                                      children: /*#__PURE__*/_jsxs("b", {
                                        children: [/*#__PURE__*/_jsx(PencilSquare, {
                                          size: 18
                                        }), " EDITER INTERPRETATION"]
                                      })
                                    })
                                  }, {
                                    key: '2' + e.id,
                                    label: /*#__PURE__*/_jsxs(Button, {
                                      type: "default",
                                      onClick: function onClick() {
                                        setCurrentQueueItem(q);
                                        setSelectedQueueElement(e);
                                        setShowImageInput(true);
                                        setSelectedItem(e.business_account_medical_item);
                                      },
                                      children: [/*#__PURE__*/_jsx(ImageFill, {
                                        size: 18
                                      }), " EDITER IMAGE"]
                                    })
                                  }]
                                },
                                children: /*#__PURE__*/_jsxs(Space, {
                                  children: [/*#__PURE__*/_jsx(ThreeDotsVertical, {
                                    size: 15
                                  }), /*#__PURE__*/_jsx(Tag, {
                                    color: "#f50",
                                    children: e.business_account_medical_item.label
                                  })]
                                })
                              });
                            })
                          })
                        })]
                      }, "q" + q.id);
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), isDeptDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              })
            }, 1), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(HourglassSplit, {
                  size: 35
                }), " Historique"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Code P."
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Telephone"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte"
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 1;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Moment, {
                            format: "DD/MM/YYYY HH:mm",
                            children: q.created_at
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.idnumber
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname + " " + q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.mobile.toString().slice(3)
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Space, {
                            direction: "horizontal",
                            children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                              return /*#__PURE__*/_jsx(Dropdown, {
                                placement: "bottomLeft",
                                menu: {
                                  items: [{
                                    key: '1' + e.id,
                                    label: /*#__PURE__*/_jsx(Button, {
                                      type: "default",
                                      onClick: function onClick() {
                                        setCurrentQueueItem(q);
                                        setShowResult(true);
                                        setSelectedQueueElement(e);
                                        setSelectedItem(e.business_account_medical_item);
                                      },
                                      children: /*#__PURE__*/_jsxs("b", {
                                        children: [/*#__PURE__*/_jsx(EyeFill, {
                                          size: 18
                                        }), " VOIR"]
                                      })
                                    })
                                  }, {
                                    key: '2' + e.id,
                                    label: /*#__PURE__*/_jsx(Button, {
                                      type: "default",
                                      onClick: function onClick() {
                                        setCurrentQueueItem(q);
                                        setShowEditTranslate(true);
                                        setSelectedQueueElement(e);
                                        setSelectedItem(e.business_account_medical_item);
                                      },
                                      children: /*#__PURE__*/_jsxs("b", {
                                        children: [/*#__PURE__*/_jsx(PencilSquare, {
                                          size: 20
                                        }), " EDITER INTERPRETATION"]
                                      })
                                    })
                                  }, {
                                    key: '2' + e.id,
                                    label: /*#__PURE__*/_jsx(Button, {
                                      type: "default",
                                      onClick: function onClick() {
                                        setCurrentQueueItem(q);
                                        setShowImageInput(true);
                                        setSelectedQueueElement(e);
                                        setSelectedItem(e.business_account_medical_item);
                                      },
                                      children: /*#__PURE__*/_jsxs("b", {
                                        children: [/*#__PURE__*/_jsx(ImageFill, {
                                          size: 18
                                        }), " EDITER IMAGE"]
                                      })
                                    })
                                  }]
                                },
                                children: /*#__PURE__*/_jsxs(Space, {
                                  children: [/*#__PURE__*/_jsx(ThreeDotsVertical, {
                                    size: 15
                                  }), /*#__PURE__*/_jsx(Tag, {
                                    color: "#f50",
                                    children: e.business_account_medical_item.label
                                  })]
                                })
                              });
                            })
                          })
                        })]
                      }, "h" + q.id);
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), isDeptDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              })
            }, 3), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(GraphUpArrow, {
                  size: 35
                }), " Activit\xE9s"]
              }),
              children: /*#__PURE__*/_jsx("div", {
                className: "cool-radius white-bg",
                style: {
                  minHeight: '300px'
                },
                children: currentDept && /*#__PURE__*/_jsx(SearchActivity, {
                  dcode: currentDept.dcode
                })
              })
            }, 5)]
          })]
        })
      })
    }), currentQueueItem && currentQueueItem.customer && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "NOUVEAU COMPTE RENDU"
        }),
        destroyOnClose: true,
        width: "80%",
        open: showTranslate,
        onCancel: function onCancel() {
          setShowTranslate(false);
        },
        footer: null,
        children: /*#__PURE__*/_jsx(SetImResult, {
          im_type: "scanner",
          q_item: currentQueueItem,
          m_item: selectedItem,
          handler: function handler() {
            setShowTranslate(false);
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Données enregistrée"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "SAUVEGARDER LE CLICHET"
        }),
        destroyOnClose: true,
        width: "80%",
        open: showImageInput,
        onCancel: function onCancel() {
          setShowImageInput(false);
        },
        footer: null,
        children: /*#__PURE__*/_jsx(SetImFile, {
          im_type: "scanner",
          q_item: currentQueueItem,
          m_item: selectedItem,
          handler: function handler() {
            setShowImageInput(false);
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Données enregistrée"
            });
          }
        })
      }), selectedQueueElement && selectedQueueElement.im_result && currentQueueItem.customer && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Drawer, {
          title: /*#__PURE__*/_jsx("b", {
            children: "COMPTE RENDU DU SCANNER"
          }),
          destroyOnClose: true,
          width: "95%",
          open: showResult,
          onClose: function onClose() {
            setShowResult(false);
          },
          extra: [/*#__PURE__*/_jsx(ReactToPrint, {
            content: function content() {
              return ref.current;
            },
            children: /*#__PURE__*/_jsx(PrintContextConsumer, {
              children: function children(_ref) {
                var handlePrint = _ref.handlePrint;
                return /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  onClick: handlePrint,
                  children: /*#__PURE__*/_jsx("b", {
                    children: "IMPRIMER"
                  })
                });
              }
            })
          })],
          children: /*#__PURE__*/_jsx(ImResultView, {
            ref: ref,
            business_account_medical_item: selectedQueueElement.business_account_medical_item,
            im_result: selectedQueueElement.im_result,
            customer: currentQueueItem.customer
          })
        }), /*#__PURE__*/_jsx(Modal, {
          title: /*#__PURE__*/_jsx("b", {
            children: "EDITER LE COMPTE RENDU"
          }),
          destroyOnClose: true,
          width: "80%",
          open: showEditTranslate,
          onCancel: function onCancel() {
            setShowEditTranslate(false);
          },
          footer: null,
          children: /*#__PURE__*/_jsx(SetImResult, {
            im_object: selectedQueueElement.im_result,
            q_item: currentQueueItem,
            m_item: selectedItem,
            handler: function handler() {
              setShowEditTranslate(false);
              setDataChanged(true);
              notification.success({
                message: "Ok!",
                description: "Données enregistrée"
              });
            }
          })
        })]
      })]
    })]
  });
};
export default Echographie;